module.exports = __webpack_public_path__ + "static/media/one.725d265d.svg";